import React from 'react';
import { companies, showCompanyPlaceholders, companyPlaceholderCount, projects } from '../../data/logos';

function LogoTile({ item }) {
  const Tag = item.url ? 'a' : 'div';
  const linkProps = item.url ? { href: item.url, target: '_blank', rel: 'noopener noreferrer', 'aria-label': `${item.name} (opens in a new tab)` } : {};

  return (
    <li>
      <Tag className={`tt-logo-tile${item.url ? ' is-link' : ''}`} {...linkProps}>
        <span className="tt-logo-mark">
          {item.logo ? <img src={item.logo} alt={`${item.name} logo`} loading="lazy" /> : <span className="tt-logo-word" aria-hidden="true">{item.name}</span>}
        </span>
        <span className="tt-logo-caption">
          <strong>{item.name}</strong>{item.role && <span>{item.role}</span>}
        </span>
      </Tag>
    </li>
  );
}

export default function LogoWall({ track = 'teach' }) {
  // One merged wall: products Usama built first, then companies he has worked with.
  const items = [...projects, ...companies];
  const placeholders = companies.length === 0 && showCompanyPlaceholders ? companyPlaceholderCount : 0;

  return (
    <section className="tt-logos" id="worked-with" aria-labelledby="logos-title">
      <div className="tt-wrap">
        <div className="tt-section-head">
          <p className="tt-eyebrow">Companies &amp; projects</p>
          <h2 id="logos-title">
            {track === 'teach' ? 'AI products built and taught from experience.' : 'AI products & systems built from scratch.'}
          </h2>
        </div>

        <div className="tt-logo-group">
          <div className="tt-logo-side">
            <h3>{track === 'teach' ? 'Live product examples' : 'Companies & products'}</h3>
            <p>
              {track === 'teach'
                ? 'AI products Usama has founded and built, used as live examples in his training sessions.'
                : 'Products Usama has founded and built, and organisations he has worked with.'}
            </p>
          </div>
          <ul className="tt-logo-grid">
            {items.map((item) => <LogoTile item={item} key={item.name} />)}
            {Array.from({ length: placeholders }, (_, i) => (
              <li key={`placeholder-${i}`}>
                <div className="tt-logo-tile is-placeholder" aria-hidden="true">
                  <span className="tt-logo-word">Company logo</span>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
